export default `
	fragment AccountNavigationFragment on AccountNavigation {
		id
		title
		url
		icon
		sequence
		enabled
		createdDate
		updatedDate
	}
`;
